import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { LANGUAGES, NAV_ITEMS } from '../../data/navigation'
import { useLanguage } from '../../hooks/useLanguage'
import { ButtonElement, ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { Flag } from '../Icon/Flag'
import { Icon } from '../Icon/Icon'
import styles from './MobileMenu.module.scss'

interface MobileMenuProps {
  onClose: () => void
  onGetPromo: () => void
}

export const MobileMenu = ({ onClose, onGetPromo }: MobileMenuProps) => {
  const { t } = useTranslation()
  const { changeLanguage, language } = useLanguage()

  useEffect(() => {
    document.body.classList.add('no-scroll')
    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [])

  return (
    <div className={styles.menu} role="presentation">
      <button aria-label={t('menu.close')} className={styles.backdrop} type="button" onClick={onClose} />
      <div className={styles.panel}>
        <button aria-label={t('menu.close')} className={styles.close} type="button" onClick={onClose}>
          <Icon name="close" size={24} />
        </button>
        <nav aria-label={t('menu.navAria')}>
          <ul className={styles.nav}>
            <li>
              <a className={`${styles.link} ${styles.active}`} href="#top" onClick={onClose}>
                {t('menu.home')}
              </a>
            </li>
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a className={styles.link} href={item.href} onClick={onClose}>
                  {t(item.labelKey)}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <hr className={styles.divider} />
        <ul className={styles.languages}>
          {LANGUAGES.map((item) => (
            <li key={item.code}>
              <button
                className={`${styles.language}${item.code === language ? ` ${styles.active}` : ''}`}
                type="button"
                onClick={() => {
                  changeLanguage(item.code)
                }}
              >
                <Flag code={item.flag} size={24} />
                <span>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
        <button
          className={styles.promo}
          type="button"
          onClick={() => {
            trackButtonClick(ButtonElement.GetPromocode, ButtonLocation.Header)
            onGetPromo()
          }}
        >
          {t('header.getPromo')}
        </button>
      </div>
    </div>
  )
}
